import { TAnswers, TQuizAnswer } from 'models/common.model'
import { TWoofyOnboardingChipSlot } from 'nove8/cohorts/woofz_woofy1/pages/chat/coach/helpers/resolveWoofyOnboardingChipSlots'
import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

interface IGlobalSessionStore {
  accountEmail: string
  shouldShowPaymentOfferScreen: boolean
  cookieyesConsent: boolean
  isDoNotSellInfoAvailable: boolean
  isCookiePolicyAvailable: boolean
  isViewPriceEventSent: boolean
  isStepBack?: boolean
  isFirstPageLoad?: boolean
  emailPayPalAppToWeb: string
  dogBreedValue: string | null
  isWebAppRedirect: boolean
  isPrintablePdf: boolean
  language: string
  userAnswers: TAnswers | TQuizAnswer | null // only for local use, for common use get from lead
  isPitPatInterested: boolean
  hasStickyBannerViewPriceEventSent: boolean
  hasEmailConsent: boolean
  isUpsellPaid: boolean // used only for old subscriptions
  hasAccount: boolean // used only for old subscriptions
  hasSubscription: boolean // used only for old subscriptions
  emailConsent: boolean // used only for old subscriptions
  isLinkPaymentMethod: boolean
  mediaSourceSearchParam: string
  wasUpsellTooltipShown: boolean
  hasInvoxiaFormSubmitted: boolean
  userPhoneNubmer: string
  isSlicedCoachingSteps: boolean
  currenDogId: string | null
  woofyDogName: string
  woofyChatOnboardingChipSlots: TWoofyOnboardingChipSlot[]
  woofyChatUserId: string
  woofyTalkConversationId: string
  woofyPrepareId: string
  woofyPrepareConversationId: string
  woofyPrepareVersion: 1 | 2 | null
  woofyConversationStored: boolean
  isOfferDiscountTimeout: boolean
  isCancelOfferDiscountTimeout: boolean
  isPaypalPurchaseSuccess: boolean
}

const INITIAL_SESSION_STORE: IGlobalSessionStore = {
  accountEmail: '',
  shouldShowPaymentOfferScreen: false,
  cookieyesConsent: false,
  isDoNotSellInfoAvailable: false,
  isCookiePolicyAvailable: false,
  isViewPriceEventSent: false,
  isStepBack: false,
  isFirstPageLoad: false,
  emailPayPalAppToWeb: '',
  dogBreedValue: null,
  isWebAppRedirect: false,
  isPrintablePdf: false,
  language: '',
  userAnswers: null,
  isPitPatInterested: false,
  hasStickyBannerViewPriceEventSent: false,
  hasEmailConsent: true,
  isUpsellPaid: false,
  hasAccount: false,
  hasSubscription: false,
  emailConsent: false,
  isLinkPaymentMethod: false,
  mediaSourceSearchParam: 'facebook_ads',
  wasUpsellTooltipShown: false,
  hasInvoxiaFormSubmitted: false,
  userPhoneNubmer: '',
  isSlicedCoachingSteps: false,
  currenDogId: null,
  woofyDogName: '',
  woofyChatOnboardingChipSlots: [],
  woofyChatUserId: '',
  woofyTalkConversationId: '',
  woofyPrepareId: '',
  woofyPrepareConversationId: '',
  woofyPrepareVersion: null,
  woofyConversationStored: false,
  isOfferDiscountTimeout: false,
  isCancelOfferDiscountTimeout: false,
  isPaypalPurchaseSuccess: false,
}

export const useZustandSessionStore = create<IGlobalSessionStore>()(
  persist(() => INITIAL_SESSION_STORE, {
    name: 'session-data-storage',
    storage: createJSONStorage(() => sessionStorage),
  }),
)
export const useZustandGlobalSessionStore = useZustandSessionStore
